const OTROS = '00'
const FACTURA = '01'
const RECIBO_HONORARIOS = '02'
const BOLETA = '03'
const LIQUIDACION_DE_COMPRAS = '04'
const NOTA_CREDITO = '07'
const NOTA_DEBITO = '08'
const GUIA_REMISION_REMITENTE = '09'
const TICKET_CINTA_EMITIDO = '12'
const DOCUMENTO_EMITIDO_BANCOS = '13'
const RECIBO_SERVICIOS = '14'
const BOLETO_EMITIDO = '15'
const BOLETO_VIAJE = '16'
const COMPROBANTE_RETENCION = '20'
const SEGURO_COMPLEMENTARIO = '27'
const DOCUMENTOS_EMITIDOS = '30'
const GUIA_REMISION_TRANSPORTISTA = '31'
const COMPROBANTE_NO_DOMICILIADO = '91'
const SERAFINADO = 'SE'
const CONSUMO = 'CO'

const __dictionary = {
  [OTROS]: {
    id: OTROS,
    nombre: '00 - OTROS'
  },
  [FACTURA]: {
    id: FACTURA,
    nombre: '01 - FACTURA'
  },
  [RECIBO_HONORARIOS]: {
    id: RECIBO_HONORARIOS,
    nombre: '02 - RECIBO POR HONORARIOS'
  },
  [BOLETA]: {
    id: BOLETA,
    nombre: '03 - BOLETA'
  },
  [LIQUIDACION_DE_COMPRAS]: {
    id: LIQUIDACION_DE_COMPRAS,
    nombre: '04 - LIQUIDACION DE COMPRAS'
  },
  [NOTA_CREDITO]: {
    id: NOTA_CREDITO,
    nombre: '07 - NOTA CREDITO'
  },
  [NOTA_DEBITO]: {
    id: NOTA_DEBITO,
    nombre: '08 - NOTA DEBITO'
  },
  [GUIA_REMISION_REMITENTE]: {
    id: GUIA_REMISION_REMITENTE,
    nombre: '09 - GUIA REMISION REMITENTE'
  },
  [TICKET_CINTA_EMITIDO]: {
    id: TICKET_CINTA_EMITIDO,
    nombre: '12 - TICKET O CINTA EMITIDO POR MÁQUINA REGISTRADORA'
  },
  [DOCUMENTO_EMITIDO_BANCOS]: {
    id: DOCUMENTO_EMITIDO_BANCOS,
    nombre: '13 - DOCUMENTO EMITIDO POR BANCOS, INSTITUCIONES FINANCIERAS, CREDITICIAS Y DE SEGUROS QUE SE ENCUENTREN BAJO EL CONTROL DE LA SUPERINTENDENCIA DE BANCA Y SEGUROS'
  },
  [RECIBO_SERVICIOS]: {
    id: RECIBO_SERVICIOS,
    nombre: '14 - RECIBO POR SERVICIOS PÚBLICOS DE SUMINISTRO DE ENERGÍA ELÉCTRICA, AGUA, TELÉFONO, TELEX Y TELEGRÁFICOS Y OTROS SERVICIOS COMPLEMENTARIOS QUE SE INCLUYAN EN EL RECIBO DE SERVICIO PÚBLICO'
  },
  [BOLETO_EMITIDO]: {
    id: BOLETO_EMITIDO,
    nombre: '15 - BOLETO EMITIDO POR LAS EMPRESAS DE TRANSPORTE PÚBLICO URBANO DE PASAJEROS'
  },
  [BOLETO_VIAJE]: {
    id: BOLETO_VIAJE,
    nombre: '16 - BOLETO DE VIAJE EMITIDO POR LAS EMPRESAS DE TRANSPORTE PÚBLICO INTERPROVINCIAL DE PASAJEROS DENTRO DEL PAÍS'
  },
  [COMPROBANTE_RETENCION]: {
    id: COMPROBANTE_RETENCION,
    nombre: '20 - COMPROBANTE DE RETENCIÓN'
  },
  [SEGURO_COMPLEMENTARIO]: {
    id: SEGURO_COMPLEMENTARIO,
    nombre: '27 - SEGURO COMPLEMENTARIO DE TRABAJO DE RIESGO'
  },
  [DOCUMENTOS_EMITIDOS]: {
    id: DOCUMENTOS_EMITIDOS,
    nombre: '30 - DOCUMENTOS EMITIDOS POR LAS EMPRESAS QUE DESEMPEÑAN EL ROL ADQUIRENTE EN LOS SISTEMAS DE PAGO MEDIANTE TARJETAS DE CRÉDITO Y DÉBITO'
  },
  [GUIA_REMISION_TRANSPORTISTA]: {
    id: GUIA_REMISION_TRANSPORTISTA,
    nombre: '31 - GUIA REMISION TRANSPORTISTA'
  },
  [COMPROBANTE_NO_DOMICILIADO]: {
    id: COMPROBANTE_NO_DOMICILIADO,
    nombre: '91 - COMPROBANTE DE NO DOMICILIADO                                                 '
  },
  [SERAFINADO]: {
    id: SERAFINADO,
    nombre: 'SE - SERAFINADO'
  },
  [CONSUMO]: {
    id: CONSUMO,
    nombre: 'CO - CONSUMO'
  }
}

const __array = [
  __dictionary[FACTURA],
  __dictionary[BOLETA],
  __dictionary[OTROS],
  __dictionary[RECIBO_HONORARIOS],
  __dictionary[NOTA_CREDITO],
  __dictionary[NOTA_DEBITO],
  __dictionary[LIQUIDACION_DE_COMPRAS],
  __dictionary[GUIA_REMISION_REMITENTE],
  __dictionary[GUIA_REMISION_TRANSPORTISTA]
]

const __ventasArray = [__dictionary[FACTURA], __dictionary[BOLETA], __dictionary[OTROS]]
const __comprasArray = [
  __dictionary[OTROS],
  __dictionary[FACTURA],
  __dictionary[BOLETA],
  __dictionary[NOTA_CREDITO],
  __dictionary[NOTA_DEBITO],
  __dictionary[LIQUIDACION_DE_COMPRAS]
]
const __compraOrdenesCompraArray = [__dictionary[OTROS], __dictionary[GUIA_REMISION_REMITENTE]]
const __guiasOrdenArray = [__dictionary[OTROS], __dictionary[GUIA_REMISION_REMITENTE]]

const __values = [
  OTROS,
  FACTURA,
  BOLETA,
  LIQUIDACION_DE_COMPRAS,
  NOTA_CREDITO,
  NOTA_DEBITO,
  GUIA_REMISION_REMITENTE,
  GUIA_REMISION_TRANSPORTISTA,
  SERAFINADO,
  CONSUMO
]

const __akdemicArray = [
  __dictionary[FACTURA],
  __dictionary[BOLETA],
  __dictionary[OTROS],
  __dictionary[RECIBO_HONORARIOS],
  __dictionary[NOTA_CREDITO],
  __dictionary[NOTA_DEBITO],
  __dictionary[LIQUIDACION_DE_COMPRAS],
  __dictionary[GUIA_REMISION_REMITENTE],
  __dictionary[TICKET_CINTA_EMITIDO],
  __dictionary[DOCUMENTO_EMITIDO_BANCOS],
  __dictionary[RECIBO_SERVICIOS],
  __dictionary[BOLETO_EMITIDO],
  __dictionary[BOLETO_VIAJE],
  __dictionary[COMPROBANTE_RETENCION],
  __dictionary[SEGURO_COMPLEMENTARIO],
  __dictionary[DOCUMENTOS_EMITIDOS],
  __dictionary[GUIA_REMISION_TRANSPORTISTA],
  __dictionary[COMPROBANTE_NO_DOMICILIADO]
]

export default Object.freeze({
  OTROS,
  FACTURA,
  BOLETA,
  LIQUIDACION_DE_COMPRAS,
  NOTA_CREDITO,
  NOTA_DEBITO,
  GUIA_REMISION_REMITENTE,
  GUIA_REMISION_TRANSPORTISTA,
  SERAFINADO,
  CONSUMO,
  __dictionary,
  __array,
  __ventasArray,
  __comprasArray,
  __compraOrdenesCompraArray,
  __guiasOrdenArray,
  __values,
  __akdemicArray
})
